export enum AuthType {
    Email = 'email',
    Mobile = 'mobile',
    Password = 'password'
}

export enum OrgTypes {
    SYSADM = 'SYSADM',
    Vendor = 'Vendor',
    Company = 'Company',
}

export enum Genders {
    MALE = 'Male',
    FEMALE = 'Female',
    PreferNotToSay = 'Prefer Not to Say',
}

export enum UserRoles {
    PAX = 'PAX',
}

export enum ReportDownloadFileTypes {
    PDF = 'PDF',
    csv = 'CSV'
}
export enum ReportTypes {
    daywiseDeviceTransactionsSummary = 'Daywise Device Transactions Summary',
    daywiseManualTransactionsSummary = 'Daywise Manual Transactions Summary',
    deviceTransactions = 'Device Transactions',
    manualTransactions = 'Manual Transactions',
}

export enum NotifyTypes {
    SMS = 'SMS',
    EMAIL = 'EMAIL',
    COPY = 'COPY',
}

export enum NotifyToTypes {
    Confirmation = 'Confirmation',
    Driver = 'Driver',
    Guest = 'Guest',
}

export const TemplateTypes = {
    SMS: 'SMS',
    EMAIL: 'EMAIL'
}

export const EncodingTypes = {
    TEXT: 'TEXT',
    HTML: 'HTML'
}

// export const TripStatus = {
//   All: "",
//   Created: 'created',
//   'Driver Submitted': 'driver submitted',
// }

export enum TripStatus {
    created = 'created',
    started = 'started',
    ended = 'ended',
    driverSubmitted = 'driver submitted',
    // invoiceDetails = 'Invoice Details',
}

export const SortDirections = {
    Ascending: 'asc',
    Descending: 'desc'
}

export const localStorageKeys = {
    webConfig: 'webConfig',
}

export const tripColumns = {
    serialNumber: 'serialNumber',
    bookingId: 'bookingId',
    date: 'date',
    bookedByDetails: 'bookedByDetails',
    guestDetails: 'guestDetails',
    vehicleDetails: 'vehicleDetails',
    driverDetails: 'driverDetails',
    actions: 'actions',
}

export enum Role {
    ADMIN = 'Admin',
    CLIENT = 'Client',
    DELIVERY_PERSONNEL = 'PickupMan'
}

export enum BookingStatus {
    CREATED = 'Created',
    PICKED_UP = 'Picked Up',
    IN_TRANSIT = 'In Transit',
    REACHED_FACILITY = 'Reached Facility',
    OUT_FOR_DELIVERY = 'Out For Delivery',
    DELIVERED = 'Delivered',
}